"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.drawAll = exports.close = exports.isOpen = exports.open = exports.get = void 0;
var rogueColors_1 = require("@dive/colors/rogueColors");
var rogueMonofont_sidecar_1 = require("@dive/fonts/rogueMonofont-sidecar");
var diveMessages_sidecar_1 = require("@dive/misc/diveMessages-sidecar");
var _obj = null;
var get = function () {
    if (!_obj) {
        _obj = {
            isOpen: false,
        };
    }
    return _obj;
};
exports.get = get;
var open = function () {
    var obj = exports.get();
    obj.isOpen = true;
    // rogueUiDead.close()
};
exports.open = open;
var isOpen = function () {
    return exports.get().isOpen;
};
exports.isOpen = isOpen;
var close = function () {
    var obj = exports.get();
    obj.isOpen = false;
};
exports.close = close;
var drawAll = function () {
    var obj = exports.get();
    if (!obj.isOpen) {
        return;
    }
    var x = 1;
    var y = 1;
    rogueMonofont_sidecar_1.rogueMonofont.write(x, y, 'Messages', rogueColors_1.rogueColors.light, rogueColors_1.rogueColors.darkBlue);
    // y++
    var messages = diveMessages_sidecar_1.diveMessages.getAll();
    for (var i = 0; i < messages.length; i++) {
        var item = messages[messages.length - i - 1]; // Reverse order
        y++;
        rogueMonofont_sidecar_1.rogueMonofont.write(x, y, item, rogueColors_1.rogueColors.light, rogueColors_1.rogueColors.dark);
    }
};
exports.drawAll = drawAll;
